import type { SourceDocument } from "@/types/domain";

/** 来源标签走 i18n（components:sourceDocuments.<id>） */
export const SOURCE_DOCUMENTS: SourceDocument[] = [
  { id: "spf", year: "2026" },
  { id: "timeline", year: "2026-2027" },
  { id: "ismp", year: "2017" },
  { id: "seeds", year: "2025-2026" },
];
